const SupportNavigation = () => {
  return <div></div>;
};

export default SupportNavigation;
